module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Computer_16"],"path":[{"$":{"d":"M13,3V9H3V3H13m2-2H1V11H15V1ZM10,12v1H6V12H1L0,15H16l-1-3Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Computer_16.svg
// module id = mmaZ
// module chunks = 1